import { useEffect } from 'react';
import { getGoogleAnalyticsClientId } from 'firebase/analytics';
import { useDispatch, useSelector } from '@client/hooks/redux.hooks';
import { setGoogleAnalyticsClientId } from '@client/slices/helpers/session.reducer';
import { hasFirebaseScaffolded } from '@client/selectors/helpers/clients';

export const useGoogleAnalyticsClientId = () => {
  const dispatch = useDispatch();
  const firebaseLoaded = useSelector(hasFirebaseScaffolded);

  useEffect(() => {
    if (firebaseLoaded) {
      const getClientId = async () => {
        let clientId = null;

        try {
          clientId = await getGoogleAnalyticsClientId(window.Firebase.analytics);
        } catch (e) {
          console.log('unable to retrieve clientId', e);
        }

        dispatch(setGoogleAnalyticsClientId(clientId));

        return clientId;
      };

      void getClientId();
    }
  }, [dispatch, firebaseLoaded]);
};
